import { apiFetch } from './utils/api';

export const podcastEpisodes = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v2/podcast-episodes';

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
